/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/api.proto
 * OpenAPI spec version: version not set
 */

export type QueryAutomationStage =
  (typeof QueryAutomationStage)[keyof typeof QueryAutomationStage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QueryAutomationStage = {
  AUTOMATION_STAGE_UNSPECIFIED: 'AUTOMATION_STAGE_UNSPECIFIED',
  AUTOMATION_STAGE_DRAFT: 'AUTOMATION_STAGE_DRAFT',
  AUTOMATION_STAGE_PUBLISHED: 'AUTOMATION_STAGE_PUBLISHED',
} as const;
